import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import Text from '../../typography'
import styled from '@emotion/styled';
import {theme} from '../../../themes/default-theme';
import NewPostcodePopup from '../../ui/NewPostcodePopup';
import ReactHtmlParser from 'react-html-parser';

const Wrapper = styled.div`
    
`

const Container = styled.div`
    max-width: 1400px;
    margin: auto;
    ${props => props.hide == 'show' && `
        margin-bottom: 35px;
        ${theme.breakpoints.down('sm')} { 
            margin-top: 40px;
        }
    `}
`
const LocationContainer = styled.div`
    margin-bottom: 20px;
    ${theme.breakpoints.up('md')} { 
        > div, > a {
            margin-right: 3px;
            font-size: 16px;
            line-height: 23px;
            display: inline-block;
            color: #758094;
        }
    }
    ${theme.breakpoints.down('sm')} {
        > div, > a {
            margin-right: 3px;
            font-size: 14px;
            line-height: 23px;
            display: inline-block;
            color: #758094;
        }
    }
`
const FooterNote = styled.div`
    > div {
        font-size: 10px;
        line-height: 16px;
        color: #2E3238;
    }
`

const modelFooterDefaultPropDealers = [];
const modelFooterDefaultPropGetCurrentSetSetLocation = () => {};
const modelFooterDefaultPropSetOpenPostcodePopup = () => {};

const ModelFooter = (props) => {
    props = {
        ...props,
        text: typeof props.text === "undefined" ? null : props.text,
        dealers: typeof props.dealers === "undefined" ? modelFooterDefaultPropDealers : props.dealers,
        postcode: typeof props.postcode === "undefined" ? '' : props.postcode,
        getCurrentSetSetLocation: typeof props.getCurrentSetSetLocation === "undefined" ? modelFooterDefaultPropGetCurrentSetSetLocation : props.getCurrentSetSetLocation,
        openPostcodePopup: typeof props.openPostcodePopup === "undefined" ? false : props.openPostcodePopup,
        setOpenPostcodePopup: typeof props.setOpenPostcodePopup === "undefined" ? modelFooterDefaultPropSetOpenPostcodePopup : props.setOpenPostcodePopup,
        hide: typeof props.hide === "undefined" ? false : props.hide,
        staticData: typeof props.staticData === "undefined" ? false : props.staticData,
        buildPriceDisclaimer: typeof props.buildPriceDisclaimer === "undefined" ? null : props.buildPriceDisclaimer,
        showBuildPriceDisclaimerOnly: typeof props.showBuildPriceDisclaimerOnly === "undefined" ? false : props.showBuildPriceDisclaimerOnly
    };

    const {
      text,
      dealers,
      countryProps,
      getCurrentSetSetLocation,
      openPostcodePopup,
      setOpenPostcodePopup,
      hide,
      staticData,
      buildPriceDisclaimer,
      showBuildPriceDisclaimerOnly
    } = props;

    const dealerTitle = typeof window !== 'undefined' && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}";

    const [postcodeOpen, setPostcodeOpen] = useState(false);
    
    const [SelectedDealerState, setSelectedDealerState] = useState(null);
    const [getLocation, setGetLocation] = useState({});

    const handlePostcodePopup = (e) => {
          e.preventDefault();
          setPostcodeOpen(true);
    }

    const handlePostcodeStatus = () => {
      setPostcodeOpen(false); 
      setOpenPostcodePopup(false);
    }

    const getCurrentLocation = (currentLocation) => {
      setGetLocation(currentLocation)
      getCurrentSetSetLocation(currentLocation);
    }
    useEffect(() => {
      setSelectedDealerState(
          typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer') ?  typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer') : typeof window != 'undefined' && window.localStorage.getItem('dealer') ? typeof window != 'undefined' && window.localStorage.getItem('dealer') : null
      )

      const SelectedDealer = typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer') ?  typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer') : typeof window != 'undefined' && window.localStorage.getItem('dealer') ? typeof window != 'undefined' && window.localStorage.getItem('dealer') : null

      if (!SelectedDealer) {
        setPostcodeOpen(true);
      }
    }, [])
    useEffect(() => {
      setGetLocation(SelectedDealerState);
      getCurrentSetSetLocation(SelectedDealerState);
    }, [SelectedDealerState])

    useEffect(() => {
      openPostcodePopup &&
      setPostcodeOpen(openPostcodePopup)
    }, [openPostcodePopup])
    

    return (
      <Wrapper>
          <Container type={hide ? 'hide' : 'show'}>
              {process.env.DEALER_SITE !== true &&
                  postcodeOpen &&
                      <NewPostcodePopup 
                          dealers={dealers}
                          countryProps={countryProps}
                          postcodeStatus={handlePostcodeStatus}
                          getCurrentSetLocation={getCurrentLocation}
                          staticData={staticData ? true : false}
                      />
              }
              {process.env.DEALER_SITE !== true ? 
                  (!hide &&
                      <>
                          {!showBuildPriceDisclaimerOnly &&
                              <LocationContainer>
                                  {getLocation &&
                                      <>
                                          <Text variant="body2" weight={700}>Dealer:</Text>
                                          {getLocation && typeof getLocation == 'string' &&  JSON.parse(getLocation).data &&  JSON.parse(getLocation).title && <Text variant="body2">{ JSON.parse(getLocation).title},</Text>}
                                          {getLocation && typeof getLocation == 'string' &&  JSON.parse(getLocation).data &&  JSON.parse(getLocation).data.contact?.suburb && <Text variant="body2">{ JSON.parse(getLocation).data.contact.suburb},</Text>}
                                          {getLocation && typeof getLocation == 'string' &&  JSON.parse(getLocation).data &&  JSON.parse(getLocation).data.contact?.state && <Text variant="body2">{ JSON.parse(getLocation).data.contact.state},</Text>}
                                          {getLocation && typeof getLocation == 'string' &&  JSON.parse(getLocation).data &&  JSON.parse(getLocation).data.contact?.postcode && <Text variant="body2">{ JSON.parse(getLocation).data.contact.postcode}</Text>}
                                      </>
                                  }
                                  {!staticData && <a href="#" onClick={(e) => {handlePostcodePopup(e)}}>{getLocation ? 'Change' :'Add your postcode first'}</a>}
                              </LocationContainer>
                          }
                          {(text || buildPriceDisclaimer) &&
                              <FooterNote>
                                  {text && !showBuildPriceDisclaimerOnly &&
                                      <Text variant="body2">{ReactHtmlParser(text)}</Text>
                                  }
                                  {buildPriceDisclaimer &&
                                          <Text variant="body2">{ReactHtmlParser(buildPriceDisclaimer)}</Text>
                                  }
                              </FooterNote>
                          }
                      </>
                  )
              :
                  
                  !hide &&
                      <>
                          {dealerTitle &&  !showBuildPriceDisclaimerOnly &&
                              <LocationContainer>
                                  <>
                                      <Text variant="body2" weight={700}>Dealer:</Text>
                                      <Text variant="body2">{ dealerTitle}</Text>
                                  </>
                              </LocationContainer>
                          }
                          {(text || buildPriceDisclaimer) &&
                              <FooterNote>
                                  {text &&  !showBuildPriceDisclaimerOnly &&
                                      <Text variant="body2">{ReactHtmlParser(text)}</Text>
                                  }
                                  {buildPriceDisclaimer &&
                                          <Text variant="body2">{ReactHtmlParser(buildPriceDisclaimer)}</Text>
                                  }
                              </FooterNote>
                          }
                      </>
              }
          </Container>
      </Wrapper>
    )
}

ModelFooter.propTypes = {
    text: propTypes.string,
    dealers: propTypes.array,
    postcode: propTypes.string,
    getCurrentSetSetLocation: propTypes.func,
    openPostcodePopup: propTypes.bool,
    setOpenPostcodePopup: propTypes.func,
    hide: propTypes.bool,
    staticData: propTypes.bool,
    buildPriceDisclaimer: propTypes.string,
    showBuildPriceDisclaimerOnly: propTypes.bool
}

export default ModelFooter